import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  doingBusinessAs: null,
  doingBusinessAsList: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const doingBusinessAsReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.DOINGBUSINESSAS_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.DOINGBUSINESSAS_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.DOINGBUSINESSAS_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default doingBusinessAsReducer;
